import api from '../../lib/api';
import {  url_api_v1_sb_profile_mediareq, url_api_v1_sk_doc_add, url_api_v1_sk_doc_remove, url_api_v1_sk_get, url_api_v1_sk_search_get } from '../../lib/apiUrl';
import { SubmissionKitDocumentModel } from '../submission_kits/components/KitModels';

class SubmissionKitService {
  getSubmissionKitDocumentById = async (sk_id:string) => {
    try {
      const url = url_api_v1_sk_get.replace(':sk_id', sk_id);
      const response = await api.get(url);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error in getting submission kit documents.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  getSubmissionKitDocument = async () => {
    try {
      const url = url_api_v1_sk_search_get;
      const response = await api.get(url);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error in getting submission kit documents.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  addInSubmissionKitDocument = async (kit_id: any, tag: string) => {
    try {
      const url = url_api_v1_sk_doc_add;
      const response = await api.post(url, {
        kit_document_id: kit_id,
        tag: tag,
      });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error in adding media in submission kit.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  deleteFromSubmissionKitDocument = async (submissionKitDocument: SubmissionKitDocumentModel) => {
    try {
      const url = url_api_v1_sk_doc_remove;
      const response = await api.post(url, {
        id: submissionKitDocument.id,
        submission_kit_id: submissionKitDocument.submission_kit_id,
        kit_document_id: submissionKitDocument.kit_document_id,
      });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error creating job.');
      }
      return true;
    } catch (error) {
      throw error;
    }
  };
  askPerformerToUploadMedia = async (project_uuid: string, sb_id: number, profile_id: number, notes: string) => {
    try {
      const url = url_api_v1_sb_profile_mediareq
        .replace(':project_uuid', project_uuid)
        .replace(':profile_id', profile_id.toString())
        .replace(':sb_id', sb_id.toString());
      const response = await api.put(url, {
      notes: notes, // <-- send notes in the request body
    });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error in requesting media for submission kit.');
      }
      return response?.data;
    } catch (error) {
      throw error;
    }
  };
}

const submissionKitService = new SubmissionKitService();

export default submissionKitService;
